<script>
export default {
    name: "GeneralReportForm",
    props: {
        value: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        classId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            hoursFromSelectedOption: this.getCurrentHour(),
            minutesFromSelectedOption: this.getCurrentMinute(),
            hoursToSelectedOption: this.getCurrentHour(),
            minutesToSelectedOption: this.getCurrentMinute(),
            hours: this.getNumbers1to24(),
            minutes: this.getNumbers0to60By10(),
            internalUpdate: false,
        };
    },
    watch: {
        value: {
            handler(newValue) {
                if (!this.internalUpdate) {
                    this.model = {...this.model, ...newValue};
                }
                this.internalUpdate = false;
            },
            deep: true,
            immediate: true,
        },
        hoursFromSelectedOption: function () {
            this.model.from = this.getFrom();
        },
        minutesFromSelectedOption: function () {
            this.model.from = this.getFrom();
        },
        hoursToSelectedOption: function () {
            this.model.to = this.getTo();
        },
        minutesToSelectedOption: function () {
            this.model.to = this.getTo();
        },
    },
    methods: {
        getCurrentHour() {
            const currentDate = new Date();
            let currentHour = currentDate.getHours();
            currentHour = currentHour.toString().padStart(2, '0');
            return {  value: currentHour };
        },
        getCurrentMinute() {
            const currentDate = new Date();
            let currentMinute = currentDate.getMinutes();
            currentMinute = Math.floor(currentMinute / 10) * 10;
            currentMinute = currentMinute.toString().padStart(2, '0');
            return { value: currentMinute };
        },
        getNumbers1to24() {
            const numbers = [];
            for (let i = 0; i <= 23; i++) {
                numbers.push({
                    value: i.toString().padStart(2, '0'),
                    text: i.toString().padStart(2, '0'),
                });
            }
            return numbers;
        },
        getNumbers0to60By10() {
            const numbers = [];
            for (let i = 0; i <= 50; i += 10) {
                numbers.push({
                    value: i.toString().padStart(2, '0'),
                    text: i.toString().padStart(2, '0'),
                });
            }
            return numbers;
        },
        getSelectItems(designer, translate) {
            let items = [];
            designer.forEach(([key, content]) => {
                key = key.toLowerCase();

                items.push({
                    value: key,
                    cls: content.BG_COLOR,
                    text: trans(translate + '.' + key),
                    color: content.TEXT_COLOR,
                    icon: content.ICON
                });
            });
            return items;
        },
    }
}
</script>
